<mat-form-field class="search-filter" appearance="fill">
  <mat-label>Filter</mat-label>
  <mat-select (selectionChange)="changeSelection()" [(value)]="selectedOption" [disabled]="disabled">
    <mat-option value="">--</mat-option>
    <mat-option *ngFor="let option of options" [value]="option" [disabled]="option.disabled">{{
      option.label
    }}</mat-option>
  </mat-select>
</mat-form-field>
